import $ from "jquery";

import "../scss/page.scss";
import "../scss/contact.scss";

import "./scripts/contact/map-load.js";
import "./scripts/contact/faq.js";

import "./scripts/popup/thank-you-popup.js";

var carouselMapInfoSlider = $('.js-map-info-slider');
var carouselMapIframeSlider = $('.js-map-iframe-slider');

carouselMapInfoSlider.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    asNavFor: carouselMapIframeSlider,
    autoplay: false,
    fade: true,
    prevArrow: $('.js-map-prev-slider'),
    nextArrow: $('.js-map-next-slider'),
    adaptiveHeight: true, 
});

carouselMapIframeSlider.slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: false,
    autoplay: false,
    asNavFor: carouselMapInfoSlider,
    fade: true,
});
